var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image__wrapper"},[_c('img',_vm._b({staticClass:"image__item",attrs:{"src":"","alt":_vm.$attrs.alt || ''}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }